import { base64ToPdf } from "./base64ToPDFConvertor";

export const shouldShowAgreement = ({ enableAgreement, agreementSigned }) =>
  enableAgreement && !agreementSigned;

export const AGREEMENT_PDF_FILES = {
  provider:
    "/Provider Agreement/Agreement - SleepNavigator Terms of Service (Provider)(616071881.11) (1).pdf",

  patient:
    "/Patient Agreement/Agreement - WellNecessities - SleepNavigator Terms of Service (Patient)(616733835.2).docx.pdf",
};

export const getPdfUrlFromBase64 = (file, name) => {
  const base64Data = file.includes(",") ? file.split(",")[1] : file;
  const fileType = name?.split(".")?.pop();
  const pdfUrl = base64ToPdf(base64Data, fileType);

  return {
    pdfUrl,
    fileType,
  };
};
